import React from 'react'
import { Route, Switch } from 'react-router-dom'

import ToolsPage from './pages/ToolsPage/ToolsPage'
import NewAddresses from './views/addressesSection/NewAddresses'
import ActiveAddresses from './views/addressesSection/ActiveAddresses'
import DeterministicRune from './views/networkSection/DeterministicRune'
import TotalValueLocked from './views/networkSection/TVLocked'
import TotalValueBonded from './views/networkSection/TVBonded'
import TotalValuePooled from './views/networkSection/TVPooled'
import EarningsBreakdown from './views/networkSection/EarningsBreakdown'
import SwapFees from './views/swapsSection/SwapFees'
import LiquidityNet from './views/liquidityPoolsSection/LiquidityNet'

import ILPPaid from './views/liquidityPoolsSection/ILPPaid'
import SwapVolume from './views/swapsSection/SwapVolume'
import SwapCount from './views/swapsSection/SwapCount'
import RefundEvents from './views/swapsSection/RefundEvents'
import AffiliateFees from './views/exchangesSection/AffiliateFees'
import CexBalances from './views/balancesSection/CexBalances'
import RuneDistribution from './views/balancesSection/RuneDistribution'
import ModuleBalances from './views/balancesSection/ModuleBalances'
import TSThorStaking from './views/thorswapSection/TSThorStaking'
import TSStakingAPR from './views/thorswapSection/TSStakingAPR'
import TSAffiliateFees from './views/thorswapSection/TSAffiliateFees'
import UniqueSwapCount from './views/swapsSection/UniqueSwapperCount'
import TSThorDistribution from './views/thorswapSection/TSThorDistribution'
import TSVThorDistribution from './views/thorswapSection/TSVThorDistribution'
import DexSwapVolume from './views/exchangesSection/DexSwapVolume'
import SwapDistribution from './views/swapsSection/SwapDistribution'

import FeaturedDashboard from './views/Featured'
import ThorswapFeaturedDashboard from './views/thorswapSection/ThorswapFeaturedDashboard'
import DexSwapCount from './views/exchangesSection/DexSwapCount'

import LiqFeesByChain from './views/networkSection/LiqFees'
import LPDistribution from './views/liquidityPoolsSection/LPDistribution'
import DexSwapVolumeCumulative from './views/exchangesSection/DexSwapVolumeCumulative'
import DexSwapCountCumulative from './views/exchangesSection/DexSwapCountCumulative'
import SwapFeesBySwapType from './views/swapsSection/SwapFeesBySwapType'
import SwapVolumeByChain from './views/swapsSection/SwapVolumeByChain'
import SwapVolumePCTByChain from './views/swapsSection/SwapVolumePCTByChain'
import TSThorPrice from './views/thorswapSection/TSThorPrice'
import CompetitorsPctSwapVolume from './views/externalSection/CompetitorsPctSwapVolume'
import CompetitorsSwapVolume from './views/externalSection/CompetitorsSwapVolume'
import AffiliateFeesCumulative from './views/exchangesSection/AffiliateFeesCumulative'
import LPDepthDistribution from './views/liquidityPoolsSection/LPDepthDistribution'
import PoolShareFactor from './views/networkSection/PoolShareFactor'
import RuneSupply from './views/networkSection/RuneSupply'
import DevFundBalance from './views/balancesSection/DevFundBalance'
import DexSwapVolumePCT from './views/exchangesSection/DexSwapVolumePCT'
import TradeAssetBalances from './views/tradeAssetsSection/TradeAssetBalances'
import TradeAssetBalanceToSwapFeesRatio from './views/tradeAssetsSection/TradeAssetBalanceToSwapFeesRatio'
import TradeAssetBalanceToSwapVolumeRatio from './views/tradeAssetsSection/TradeAssetBalanceToSwapVolumeRatio'
import TradeAssetBalanceToPoolDepthRatio from './views/tradeAssetsSection/TradeAssetBalanceToPoolDepthRatio'
import SecureAssetBalances from './views/secureAssetsSection/SecureAssetBalances'
import SecureAssetBalanceToPoolDepthRatio from './views/secureAssetsSection/SecureAssetBalanceToPoolDepthRatio'
import SecureAssetBalanceToSwapVolumeRatio from './views/secureAssetsSection/SecureAssetBalanceToSwapVolumeRatio'
import SecureAssetBalanceToSwapFeesRatio from './views/secureAssetsSection/SecureAssetBalanceToSwapFeesRatio'
import TCYStaking from './views/tcySection/TcyStaking'
import TcyRunePrice from './views/tcySection/TcyRunePriceComparison'
import TCYYield from './views/tcySection/TcyYield'
import TCYStakingAPR from './views/tcySection/TcyStakingAPR'
import TSBurnStats from './views/thorswapSection/TSBurnStats'
import TSStakingYield from './views/thorswapSection/TSStakingYield'
import MktFundBalance from './views/balancesSection/MktFundBalance'
import SwapVolumeByDepth from './views/swapsSection/SwapVolumeByDepth'
import IncomeUSDBreakdown from './views/networkSection/IncomeUSDBreakdown'
import RuneBurn from './views/networkSection/RuneBurn'
import RuneBondingAPR from './views/networkSection/RuneBondingAPR'
import IncomePolDeployments from './views/polSection/IncomePolDeployments'
import IncomePolValue from './views/polSection/IncomePolValue'
import IncomePolUnrealizedPL from './views/polSection/IncomePolUnrealizedPL'
import ReservePolValue from './views/polSection/ReservePolValue'
import ReservePolDeployments from './views/polSection/ReservePolDeployments'
import ReservePolUnrealizedPL from './views/polSection/ReservePolUnrealizedPL'
import TreasuryMSigDeployments from './views/polSection/TreasuryMSigDeployments'
import TreasuryMSigValue from './views/polSection/TreasuryMSigValue'
import TreasuryMSigUnrealizedPL from './views/polSection/TreasuryMSigUnrealizedPL'
import TreasuryOldValue from './views/polSection/TreasuryOldValue'
import TotalPolValue from './views/polSection/TotalPOLValue'

const Routes = () => {
	return (
		<Switch>
			{/* navigation bar routes */}
			<Route exact path="/">
				<FeaturedDashboard />
			</Route>
			<Route exact path="/tools">
				<ToolsPage />
			</Route>
			{/* sidebar Thorchain POL Section routes */}
			<Route exact path="/thorchain_income_pol_deployments">
				<IncomePolDeployments />
			</Route>
			<Route exact path="/thorchain_income_pol_value">
				<IncomePolValue />
			</Route>
			<Route exact path="/thorchain_income_pol_unrealized_pl">
				<IncomePolUnrealizedPL />
			</Route>

			<Route exact path="/thorchain_reserve_pol_value">
				<ReservePolValue />
			</Route>
			<Route exact path="/thorchain_reserve_pol_deployments">
				<ReservePolDeployments />
			</Route>
			<Route exact path="/thorchain_reserve_pol_unrealized_pl">
				<ReservePolUnrealizedPL />
			</Route>

			<Route exact path="/thorchain_treasury_msig_deployments">
				<TreasuryMSigDeployments />
			</Route>
			<Route exact path="/thorchain_treasury_msig_value">
				<TreasuryMSigValue />
			</Route>
			<Route exact path="/thorchain_treasury_msig_unrealized_pl">
				<TreasuryMSigUnrealizedPL />
			</Route>
			<Route exact path="/thorchain_treasury_old_value">
				<TreasuryOldValue />
			</Route>
			<Route exact path="/thorchain_total_pol_value">
				<TotalPolValue />
			</Route>

			{/* sidebar Thorchain Addresses Section routes */}
			<Route exact path="/thorchain_new_addresses">
				<NewAddresses />
			</Route>
			<Route exact path="/thorchain_active_addresses">
				<ActiveAddresses />
			</Route>
			{/* sidebar Thorchain TCY Section routes */}
			<Route exact path="/thorchain_tcy_staking">
				<TCYStaking />
			</Route>
			<Route exact path="/thorchain_tcy_rune_prices">
				<TcyRunePrice />
			</Route>
			<Route exact path="/thorchain_tcy_yield">
				<TCYYield />
			</Route>
			<Route exact path="/thorchain_tcy_staking_apr">
				<TCYStakingAPR />
			</Route>
			{/* sidebar Thorchain Trade Assets Section routes */}
			<Route exact path="/thorchain_trade_asset_balances_usd">
				<TradeAssetBalances />
			</Route>
			<Route exact path="/thorchain_trade_asset_to_swap_fees_ratio">
				<TradeAssetBalanceToSwapFeesRatio />
			</Route>
			<Route exact path="/thorchain_trade_asset_to_swap_volume_ratio">
				<TradeAssetBalanceToSwapVolumeRatio />
			</Route>
			<Route exact path="/thorchain_trade_asset_to_pool_depth_ratio">
				<TradeAssetBalanceToPoolDepthRatio />
			</Route>
			{/* sidebar Thorchain Secure Assets Section routes */}
			<Route exact path="/thorchain_secure_asset_balances_usd">
				<SecureAssetBalances />
			</Route>
			<Route exact path="/thorchain_secure_asset_to_swap_fees_ratio">
				<SecureAssetBalanceToSwapFeesRatio />
			</Route>
			<Route exact path="/thorchain_secure_asset_to_swap_volume_ratio">
				<SecureAssetBalanceToSwapVolumeRatio />
			</Route>
			<Route exact path="/thorchain_secure_asset_to_pool_depth_ratio">
				<SecureAssetBalanceToPoolDepthRatio />
			</Route>
			{/* sidebar Thorchain Network Section routes */}
			<Route exact path="/thorchain_deterministic_rune_price">
				<DeterministicRune />
			</Route>
			<Route exact path="/thorchain_tv_locked">
				<TotalValueLocked />
			</Route>
			<Route exact path="/thorchain_tv_bonded">
				<TotalValueBonded />
			</Route>
			<Route exact path="/thorchain_tv_pooled">
				<TotalValuePooled />
			</Route>
			<Route exact path="/thorchain_income_breakdown">
				<IncomeUSDBreakdown />
			</Route>
			<Route exact path="/thorchain_rune_burn">
				<RuneBurn />
			</Route>
			<Route exact path="/thorchain_rune_bonding_apr">
				<RuneBondingAPR />
			</Route>
			<Route exact path="/thorchain_earnings_breakdown">
				<EarningsBreakdown />
			</Route>
			{/* <Route exact path="/thorchain_revenue_vs_expenses">
				<TCRevenueVSExpenses />
			</Route> */}

			<Route exact path="/thorchain_bond_share_factor">
				<PoolShareFactor />
			</Route>
			<Route exact path="/thorchain_liquidity_fees">
				<LiqFeesByChain />
			</Route>
			<Route exact path="/thorchain_rune_supply">
				<RuneSupply />
			</Route>
			{/* sidebar Thorchain LiquidityPools Section routes */}

			<Route exact path="/thorchain_net_liquidity_change">
				<LiquidityNet />
			</Route>

			<Route exact path="/thorchain_ilp_paid">
				<ILPPaid />
			</Route>
			<Route exact path="/thorchain_lp_distribution">
				<LPDistribution />
			</Route>
			<Route exact path="/thorchain_lp_liquidity_distribution">
				<LPDepthDistribution />
			</Route>
			{/* sidebar Thorchain Swaps Section routes */}
			<Route exact path="/thorchain_refund_events">
				<RefundEvents />
			</Route>
			<Route exact path="/thorchain_swap_fees_by_chain">
				<SwapFees />
			</Route>
			<Route exact path="/thorchain_swap_fees_by_type">
				<SwapFeesBySwapType />
			</Route>
			<Route exact path="/thorchain_swap_volume">
				<SwapVolume />
			</Route>
			<Route exact path="/thorchain_swap_volume_by_depth">
				<SwapVolumeByDepth />
			</Route>
			<Route exact path="/thorchain_swap_volume_by_chain">
				<SwapVolumeByChain />
			</Route>
			<Route exact path="/thorchain_swap_volume_pct_by_chain">
				<SwapVolumePCTByChain />
			</Route>
			<Route exact path="/thorchain_swap_count">
				<SwapCount />
			</Route>
			<Route exact path="/thorchain_swap_count_distribution">
				<SwapDistribution />
			</Route>
			<Route exact path="/thorchain_unique_swap_count">
				<UniqueSwapCount />
			</Route>
			{/* sidebar Thorchain Exchanges Section routes */}
			<Route exact path="/thorchain_affiliate_fees">
				<AffiliateFees />
			</Route>
			<Route exact path="/thorchain_total_affiliate_fees">
				<AffiliateFeesCumulative />
			</Route>

			<Route exact path="/thorchain_swap_volume_by_aff">
				<DexSwapVolume />
			</Route>
			<Route exact path="/thorchain_swap_count_by_aff">
				<DexSwapCount />
			</Route>
			{/* <Route exact path="/thorchain_saver_adds_by_dex">
				<SaverAddsByAffAddress />
			</Route> */}
			<Route exact path="/thorchain_total_swap_volume_by_aff">
				<DexSwapVolumeCumulative />
			</Route>
			<Route exact path="/thorchain_total_swap_count_by_aff">
				<DexSwapCountCumulative />
			</Route>
			<Route exact path="/thorchain_pct_swap_volume_by_aff">
				<DexSwapVolumePCT />
			</Route>
			{/* sidebar Thorchain Balances Section routes */}
			<Route exact path="/thorchain_rune_distribution">
				<RuneDistribution />
			</Route>
			<Route exact path="/thorchain_module_balances">
				<ModuleBalances />
			</Route>
			<Route exact path="/thorchain_devfund_earnings">
				<DevFundBalance />
			</Route>
			<Route exact path="/thorchain_mktfund_earnings">
				<MktFundBalance />
			</Route>
			<Route exact path="/thorchain_cex_balance">
				<CexBalances />
			</Route>
			{/* sidebar Thorchain External Section routes */}
			<Route exact path="/thorchain_competitors_swap_vol">
				<CompetitorsSwapVolume />
			</Route>
			<Route exact path="/volume_competitors_pct_of_swap_vol">
				<CompetitorsPctSwapVolume />
			</Route>
			{/* sidebar Thorswap Section routes */}
			<Route exact path="/thorswap_dashboard">
				<ThorswapFeaturedDashboard />
			</Route>
			<Route exact path="/thorswap_staking">
				<TSThorStaking />
			</Route>
			<Route exact path="/thorswap_staking_apr">
				<TSStakingAPR />
			</Route>
			<Route exact path="/thorswap_affiliate_fees">
				<TSAffiliateFees />
			</Route>
			<Route exact path="/thorswap_thor_distribution">
				<TSThorDistribution />
			</Route>
			<Route exact path="/thorswap_vthor_distribution">
				<TSVThorDistribution />
			</Route>
			<Route exact path="/thorswap_burn_stats">
				<TSBurnStats />
			</Route>
			<Route exact path="/thorswap_staking_yield">
				<TSStakingYield />
			</Route>
			<Route exact path="/thorswap_thor_n_vthor_rune_prices">
				<TSThorPrice />
			</Route>
		</Switch>
	)
}

export default Routes
